import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState } from "react";

// ✅ Admin imports
import Login from "./Admin/Pages/Login/Login";
import Dashboard from "./Admin/Pages/Dashboard/Dashboard";
import ProductList from "./Admin/Pages/Product/ProductList";
import Layout from "./Admin/Component/Layout/Layout";
import CustomerList from "./Admin/Pages/Customer/CustomerList";
import CategoryList from "./Admin/Pages/Category/CategoryList";
import CoinAllot from "./Admin/Pages/CoinsAllotments/CoinAllotmentList";

// ✅ User imports
import UserLayout from "./User/Component/UserLayout/UserLayout";
import AddReference from "./User/Pages/Reference/AddReference";
import UserDashboard from "./User/Pages/UserDashboard/UserDashboard";
import History from "./User/Pages/History/History";
import UserLogin from "./User/Pages/UserLogin/UserLogin";
import UserOtp from "./User/Pages/UserLogin/UserOTP/UserOtp";
import ShareProduct from "./User/Pages/ShareProduct/ShareProduct";
import ReferenceList from "./User/Pages/Reference/ReferenceList/ReferenceList";
import MobileLayout from "./AdminMobile/Component/AdminMobileLayout/MobileLayout";
import MobileDashboard from "./AdminMobile/Pages/MobileDashboard/MobileDashboard";
import MobileCustomerlist from "./AdminMobile/Pages/MobileCustomer/MobileCustomerlist";
import MobileProductlist from "./AdminMobile/Pages/MobileProductlist/MobileProductlist";
import MobileLogin from "./AdminMobile/Pages/MobileLogin/MobileLogin";
import MobileCoinAllotmentList from "./AdminMobile/Pages/MobileCoinsAllotments/MobileCoinAllotmentList";
import MobileCategoryList from "./AdminMobile/Pages/MobileCategory/MobileCategorylist";

function App() {
  const [pageTitle, setPageTitle] = useState("Dashboard");

  return (
    <Router>
      <Routes>
        {/* ---------- ADMIN DESKTOP ROUTES ---------- */}
        <Route path="/" element={<Login />} />
        <Route
          path="/admin"
          element={<Layout pageTitle={pageTitle} setPageTitle={setPageTitle} />}
        >
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="customers-list" element={<CustomerList />} />
          <Route path="category-list" element={<CategoryList />} />
          <Route path="product-list" element={<ProductList />} />
          <Route path="coin-allot" element={<CoinAllot />} />
        </Route>

        {/* ---------- ADMIN MOBILE ROUTES ---------- */}
        <Route path="/adminm/login" element={<MobileLogin />} /> 
        <Route path="/adminm" element={<MobileLayout />}>
          <Route path="dashboard" element={<MobileDashboard />} />
          <Route path="customers-list" element={<MobileCustomerlist />} />
          <Route path="category-list" element={<MobileCategoryList/>} />
          <Route path="product-list" element={<MobileProductlist />} />
          <Route path="coin-allot" element={<MobileCoinAllotmentList />} />
        </Route>
        {/* ---------- USER ROUTES ---------- */}
        <Route path="/user/login" element={<UserLogin />} />
        <Route path="/user/otp" element={<UserOtp />} />
        <Route path="/user" element={<UserLayout />}>
          <Route path="dashboard" element={<UserDashboard />} />
          <Route path="dashboard/references" element={<ReferenceList />} />
          <Route path="products" element={<ShareProduct />} />
          <Route path="add-reference" element={<AddReference />} />
          <Route path="history" element={<History />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
